import React, { useState } from 'react';

/**
 * @deprecated
 */

export const AuthContext = React.createContext({
    isAuth: false,
    login: () => { },
    logout: () => { }
});

export default props => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const loginHandler = () => {
        // DO LOGIN THINGS...


        const token = 'TEST_TOKEN'
        const expireTime = new Date(new Date().getTime() + 20 * 60 * 1000);

        sessionStorage.setItem('token', token);
        sessionStorage.setItem('expireTime', expireTime);
        setIsAuthenticated(true);

        // Should reload the page when log in/out; Otherwise JQuery is not functioned.
        window.location.reload();
    }

    const logoutHandler = () => {
    	sessionStorage.removeItem('token');
    	sessionStorage.removeItem('user');
    	sessionStorage.removeItem('expireTime');
        setIsAuthenticated(false);

        window.location.reload();
    }

    const checkAuthHandler = () => {
        const token = sessionStorage.getItem('token');
        if(token){
            const expireTime = new Date(sessionStorage.getItem('expireTime'));
            if(expireTime > new Date()) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        } else {
            setIsAuthenticated(false);
        }
    }

    return (
        <AuthContext.Provider value={{
            isAuth: isAuthenticated,
            login: loginHandler,
            logout: logoutHandler,
            checkAuth: checkAuthHandler
        }}>
            {props.children}
        </AuthContext.Provider>
    );

}